import { Box, Card, Container, Flex, Loader, Stack, Text, Title } from "@mantine/core";
import { useEffect } from "react";
import { useSelector } from "react-redux";
import { useGetProjectsMaconomyQuery, useGetProjectsMcappsQuery } from "../../../../../openapi";
import { useAppDispatch, useAppSelector } from "../../../../hooks";
import { resetProjectInRedux } from "../../../actions";
import { selectMergedProjectList } from "../../../projectSelectors";
import { isLoggedinUserMulticonsultUser } from "../../admin/selectors";
import { ProjectTable } from "./ProjectTable";

export const Projects = () => {
  const dispatch = useAppDispatch();
  const isMulticonsultUser = useSelector(isLoggedinUserMulticonsultUser);

  const { isLoading: isLoadingMcapps } = useGetProjectsMcappsQuery();
  const { isLoading: isLoadingMaconomy, data } = useGetProjectsMaconomyQuery(undefined, {
    skip: isMulticonsultUser === false,
  });

  const mergedProjects = useAppSelector(selectMergedProjectList);

  useEffect(() => {
    dispatch(resetProjectInRedux());
  }, []);

  return (
    <Box style={{ paddingTop: 75, paddingBottom: 75, overflowY: "auto", flex: 1 }}>
      <Container size="lg">
        <Box maw={900} mx="auto">
          <Card maw={900} withBorder shadow="sm" p="lg">
            <Stack gap="xs">
              <Flex align="center" gap="xs">
                <Title order={3}>Prosjekter</Title>
                {(isLoadingMcapps || isLoadingMaconomy) && <Loader size={24} />}
              </Flex>

              {isMulticonsultUser && (
                <Text size="sm" c="dimmed">
                  Dine prosjekter i Maconomy
                </Text>
              )}

              <ProjectTable projects={mergedProjects} />
            </Stack>
          </Card>
        </Box>
      </Container>
    </Box>
  );
};
